import { ECheckEstimationExistsActions } from '../../constants/actionTypes/checkEstimationExists';
import { TReduxActions } from '../../types/redux';
import { ICheckEstimationExists } from '../../types/redux/checkEstimationExists';

const defaultState: ICheckEstimationExists = {
  isFetching: false,
  isNotFound: false,
};

export const checkEstimationExistsReducer = (state = defaultState, action: TReduxActions) => {
  switch (action.type) {
    case ECheckEstimationExistsActions.CHECK_ESTIMATION_EXISTS_REQUEST:
      return {
        ...state,
        isNotFound: false,
        isFetching: true,
      };

    case ECheckEstimationExistsActions.CHECK_ESTIMATION_EXISTS_ERROR:
      return {
        ...state,
        isFetching: false,
        isNotFound: true,
      };

    case ECheckEstimationExistsActions.RESET_CHECK_ESTIMATION_EXISTS:
      return {
        ...state,
        isFetching: false,
        isNotFound: false,
        estimationId: null,
        offer: null,
      };

    case ECheckEstimationExistsActions.SET_ESTIMATION_READY:
      return {
        ...state,
        isFetching: false,
        isNotFound: false,
        estimationId: action.payload.estimationId,
        offer: action.payload.offer,
      };

    default:
      return state;
  }
};
